import invariant from "tiny-invariant";

export class BlogCta extends HTMLElement {
  private readonly template: DocumentFragment;

  public constructor() {
    super();
    const template = document.querySelector(
      "[data-blog-cta-template]",
    ) as HTMLTemplateElement;

    invariant(template !== null, "Blog CTA template not found");
    this.template = template.content;
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const clone = this.template.cloneNode(true) as DocumentFragment;
    this.appendChild(clone);
  }
}
